import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import IdleTimer from 'react-idle-timer';
import {
    AllProducts,
    Questionnaire,
    Recommendations,
    TechnicalDifficulties,
    NotFound,
} from '../../containers';
import DynamicLanding from '../../containers/DynamicLanding';
import LoginWrapper from '../../molecules/LoginWrapper/LoginWrapper';
import {
    resetQuestionnaire,
    resetBankerQuestionnaire,
    resetRelationshipName,
} from '../../redux/actions';
import '../../styles/global.scss';
import BankerQuestionnaire from '../../containers/BankerQuestionnaire/BankQuestionnaire';
import BankerRecommendations from '../../containers/BankerRecommendations';
import Error from '../../containers/Error';
import RoleError from '../../containers/RoleError/RoleError';
import useEnv from '../../hooks/useEnv';

function App() {
    const dispatch = useDispatch();

    const {
        authClientId,
        authUrl,
        baseUrl,
        authTokenUrl,
        authIntrospectUrl,
        userInfoUrl,
    } = useEnv();

    function handleOnIdle() {
        dispatch(resetQuestionnaire());
        dispatch(resetBankerQuestionnaire());
        dispatch(resetRelationshipName());
    }
    const checkBanker = window.location.toString().includes('banker');
    const timeout = checkBanker ? 1000 * 60 * 120 : 1000 * 60 * 2;

    return (
        <>
            <IdleTimer
                timeout={timeout}
                onIdle={handleOnIdle}
                debounce={250}
            />

            <Switch>
                {/* <Route path="/start">
                    <Landing />
                </Route> */}
                <Route path="/questionnaire/:questionID">
                    <Questionnaire />
                </Route>
                <Route path="/recommended-products">
                    <Recommendations />
                </Route>
                <Route path="/all-products">
                    <AllProducts />
                </Route>
                <Route path="/banker/">
                    <LoginWrapper
                        baseUrl={baseUrl}
                        authUrl={authUrl}
                        authClientId={authClientId}
                        authTokenUrl={authTokenUrl}
                        authIntrospectUrl={authIntrospectUrl}
                        userInfoUrl={userInfoUrl}
                        requiredRoles={[
                            // 'ServiceNow_ESS_BRght',
                            'Invite2Apply_User',
                            'Invite2Apply_User_AD',
                            // '2325_APPLY_DB_AD_IT', // remove this before moving to IT and UAT
                        ]}
                    >
                        <Switch>
                            <Route path="/banker/start">
                                <DynamicLanding />
                            </Route>
                            <Route path="/banker/questionnaire/:questionID">
                                <BankerQuestionnaire />
                            </Route>
                            <Route path="/banker/we-have-great-options">
                                <BankerRecommendations />
                            </Route>
                            <Route path="/banker/error">
                                <Error />
                            </Route>
                            <Route path="/banker/role-error">
                                <RoleError />
                            </Route>
                            <Route exact path="/banker">
                                <Redirect to="/banker/start" />
                            </Route>
                            <Route path="*">
                                <NotFound />
                            </Route>
                        </Switch>
                    </LoginWrapper>
                </Route>
                <Route path="/tech-trouble">
                    <TechnicalDifficulties />
                </Route>
                <Route exact path="/">
                    <Redirect to="/start" />
                </Route>
                <Route path="*">
                    <NotFound />
                </Route>
            </Switch>
        </>
    );
}

export default App;
